var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-white",
    transform: "translate(-1234 733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(1234 -733)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(1236.5 -730.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    className: "cls-2",
    d: "M-.666,191.5a7.81,7.81,0,0,1-5.54-2.295,7.834,7.834,0,0,1,0-11.079L178.126-6.205a7.834,7.834,0,0,1,11.079,0,7.834,7.834,0,0,1,0,11.079L4.874,189.205A7.81,7.81,0,0,1-.666,191.5Z",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    className: "cls-2",
    d: "M183.666,191.5a7.81,7.81,0,0,1-5.54-2.295L-6.205,4.874a7.834,7.834,0,0,1,0-11.079,7.834,7.834,0,0,1,11.079,0L189.205,178.126a7.834,7.834,0,0,1-5.54,13.374Z",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.fc184e706b7f152e551488c38f8ac0be.svg";
export { ForwardRef as ReactComponent };